/* eslint-disable react/no-unknown-property */
import React from 'react';
import Icon from '@ant-design/icons';

const svg = () => (
  <svg
    width="398"
    height="159"
    viewBox="0 0 398 159"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <rect
      y="15"
      width="15"
      height="351"
      rx="4"
      transform="rotate(-90 0 15)"
      fill="url(#paint0_linear_9733_27687)"
    />
    <rect
      width="15"
      height="398"
      rx="4"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 398 51)"
      fill="url(#paint1_linear_9733_27687)"
    />
    <rect
      width="15"
      height="225"
      rx="4"
      transform="matrix(4.37114e-08 -1 -1 -4.37114e-08 225 159)"
      fill="url(#paint2_linear_9733_27687)"
    />
    <rect
      y="87"
      width="15"
      height="158"
      rx="4"
      transform="rotate(-90 0 87)"
      fill="url(#paint3_linear_9733_27687)"
    />
    <rect
      y="123"
      width="15"
      height="285"
      rx="4"
      transform="rotate(-90 0 123)"
      fill="url(#paint4_linear_9733_27687)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_9733_27687"
        x1="7.49999"
        y1="15"
        x2="7.49999"
        y2="366"
        gradientUnits="userSpaceOnUse">
        <stop stop-color="#CBCED8" />
        <stop offset="1" stop-color="#CBCED8" stop-opacity="0.33" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_9733_27687"
        x1="7.49999"
        y1="0"
        x2="7.49999"
        y2="398"
        gradientUnits="userSpaceOnUse">
        <stop stop-color="#CBCED8" />
        <stop offset="1" stop-color="#CBCED8" stop-opacity="0.33" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_9733_27687"
        x1="7.5"
        y1="0"
        x2="7.5"
        y2="225"
        gradientUnits="userSpaceOnUse">
        <stop stop-color="#CBCED8" />
        <stop offset="1" stop-color="#CBCED8" stop-opacity="0.33" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_9733_27687"
        x1="7.5"
        y1="87"
        x2="7.5"
        y2="245"
        gradientUnits="userSpaceOnUse">
        <stop stop-color="#CBCED8" />
        <stop offset="1" stop-color="#CBCED8" stop-opacity="0.33" />
      </linearGradient>
      <linearGradient
        id="paint4_linear_9733_27687"
        x1="7.49999"
        y1="123"
        x2="7.49999"
        y2="408"
        gradientUnits="userSpaceOnUse">
        <stop stop-color="#CBCED8" />
        <stop offset="1" stop-color="#CBCED8" stop-opacity="0.33" />
      </linearGradient>
    </defs>
  </svg>
);

const RectangleLoaderIcon = (props) => <Icon component={svg} {...props} />;

export default RectangleLoaderIcon;
